import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

import { CompanyOrderDetails } from '../../../models/company/company-order-details.model';
import { PhotographerOrderDetails } from '../../../models/photographer/photographer-order-details.model';
import { CommentItem } from '../../models/comment-item.model';
import { UtilitiesService } from '../../services/utilities.service';
import { UtilityFunctions } from '../../utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-sidebar-comments',
  templateUrl: './sidebar-comments.component.html',
  styleUrls: ['./sidebar-comments.component.scss']
})
export class SidebarCommentsComponent implements OnInit {

  @Input() public orderId: number;
  @Input() public style: CompanyOrderDetails | PhotographerOrderDetails;

  public comments: { data?: CommentItem[], page?: number, size: number } = {
    size: 20
  }
  public loaderId = UtilityFunctions.newGuid();
  public overflowDiv = UtilityFunctions.newGuid();
  public message: string;
  public imgPath: string;

  constructor(
    private commonService: CommonService,
    private utilitiesService: UtilitiesService
  ) { }

  public ngOnInit() {
    if (this.orderId) this.getComments(0);
  }

  public getComments(page: number) {
    this.comments.page = page;
    if (this.style) {
      this.commonService.getStyleShotsComments(this.orderId, this.comments.page, this.comments.size, this.style.modelId, this.style.colorId, null, this.loaderId)
        .subscribe(data => this.mapData(data));
    } else {
      this.commonService.getOrderComments(this.orderId, this.comments.page, this.comments.size, this.loaderId)
        .subscribe(data => this.mapData(data));
    }
  }

  public onSendMessage() {
    const text = this.message;
    this.message = null;
    if (!!text?.trim()) {
      if (this.style) {
        this.commonService.insertStyleShotsComment(this.orderId, text, this.imgPath, this.style.modelId, this.style.colorId, null, this.loaderId)
          .subscribe(() => this.getComments(0));
      } else {
        this.commonService.insertOrderComment(this.orderId, text, this.imgPath, this.loaderId)
          .subscribe(() => this.getComments(0));
      }
    } else {
      this.utilitiesService.showSnackbar('Empty message!');
    }
  }

  private mapData(data: CommentItem[]) {
    if (!this.comments.page) {
      this.comments.data = data;
      setTimeout(() => {
        const el = document.getElementById(this.overflowDiv);
        if (el) el.scrollTop = el.scrollHeight;
      });
    } else {
      this.comments.data.unshift(...data);
    }
  }
}
